import axios from "axios";
import config from "../../settings/config";
import { handleError } from "../../network/servicErrorHandling";

axios.defaults.headers.common["Authorization"] = localStorage.getItem(
  `${window.location.hostname}_token`
);

async function shopDetails(shop_uid, window_search) {
  // sent window search params to the server by query_params
  return Promise.resolve().then((v) =>
    axios
      .get(`${config.baseUrl}v1/shops/${shop_uid}${window_search}`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function shopProducts(shop_uid, searchKey, shop_category) {
  return Promise.resolve().then((v) =>
    axios
      .get(
        `${config.baseUrl}v1/products/?shop=${shop_uid}&q=${searchKey}&shop_category=${shop_category}`
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function getMoreShopProducts(nextUrl) {
  return Promise.resolve().then((v) =>
    axios
      .get(nextUrl)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

export { shopDetails, shopProducts, getMoreShopProducts };
